import { Injectable } from '@angular/core';

import { InfillsKindsUtilsService } from './kinds/tools/infills-kinds-utils.service';
import { InfillClippedByFourPointsService } from './kinds/infills-clipped-by-four-points.service';
import { Infills } from './model/infills';
import { StageService } from '../../stage.service';
import { SizeHelperService } from '../../size-helper.service';
import { ProductsService } from '../../products.service';
import { DataForDisplayingMenuItemsService } from '../../data-for-displaying-menu-items.service';
import { ConstantsService } from '../../constants.service';
import { RailingColorsService } from '../services/railing-colors.service';
import { RailingCalculationHelperService } from '../services/railing-calculation-helper.service';
import { RailLightAppendService } from '../light/rail-light-append.service';
import { InfillTypes, isPanelInfill } from './model/infill-types';
import { VerticalPicketService } from '../../vertical-picket.service';
import { MODERN_TWO_PICKET_ABOVE_INCHES } from '../../../models/2d3d/modern.config';

declare var THREE: any;

@Injectable()
export class InfillsService {
  intermediatePost: any;

  glass: any;
  glassClear: any;
  glassSmoke: any;
  glassDark: any;

  laserCutAgama: any;
  laserCutBound: any;
  laserCutCubist: any;
  laserCutPisces: any;
  laserCutRhythm: any;
  laserCutSeagrass: any;
  laserCutSverra: any;
  laserCutTrillium: any;
  laserCutPulse: any;

  steelMeshAllure: any;
  steelMeshDazzle: any;
  steelMeshMetropolitan: any;
  steelMeshHorizon: any;

  verticalPicket: any;
  horizontalCableVerticalPicket: any;
  verticalCable: any;
  horizontalCable: any;
  cornerPoints: any = [];
  intermediatePoints: any = [];
  currentParams: any;
  handrail: any;
  baserail: any;
  infills: any;
  handrailMaterial: any;
  cornerPost: any;
  insideCornerPost: any;
  dHeight: any;

  constructor(
    private stage: StageService,
    private sizeHelper: SizeHelperService,
    private productSrvc: ProductsService,
    private dataForMenu: DataForDisplayingMenuItemsService,
    private constants: ConstantsService,
    private railingColorsService: RailingColorsService,
    private railingCalculationHelperService: RailingCalculationHelperService,
    private railLightAppendService: RailLightAppendService,
    private infillsUtilsService: InfillsKindsUtilsService,
    private infillClippedByFourPointsService: InfillClippedByFourPointsService,
    private verticalPicketService: VerticalPicketService
  ) {}

  addInfills(floor, cornerPoints, intermediatePoints, infills, dHeight, railingComponent) {
    this.cornerPoints = cornerPoints;
    this.intermediatePoints = intermediatePoints;
    this.infills = infills;
    this.updateCurrentParams();
    this.dHeight = dHeight;
    this.intermediatePost = railingComponent.intermediatePost;

    this.glass = railingComponent.glass;
    // glass / laser-cut / steel-mesh panel models are keyed by their InfillTypes name
    Object.keys(InfillTypes).forEach(key => (this[key] = railingComponent[key]));

    this.verticalPicket = railingComponent.verticalPicket;
    this.horizontalCableVerticalPicket = railingComponent.horizontalCableVerticalPicket;
    this.verticalCable = railingComponent.verticalCable;
    this.horizontalCable = railingComponent.horizontalCable;
    this.handrail = railingComponent.handrail;
    this.handrailMaterial = railingComponent.handrail.children[0].material.clone();
    this.baserail = railingComponent.baserail;
    this.cornerPost = railingComponent.cornerPost;
    this.insideCornerPost = railingComponent.insideCornerPost;

    for (let i = 0; i < this.intermediatePoints.length; i++) {
      const firstToSecond135 = new THREE.Vector3(
        this.intermediatePoints[i][0].x - this.intermediatePoints[i][0].x,
        0,
        this.intermediatePoints[i][this.intermediatePoints[i].length - 1].z -
          this.intermediatePoints[i][0].z
      );
      const secondToFirst135 = new THREE.Vector3(
        this.intermediatePoints[i][0].x -
          this.intermediatePoints[i][this.intermediatePoints[i].length - 1].x,
        0,
        this.intermediatePoints[i][0].z -
          this.intermediatePoints[i][this.intermediatePoints[i].length - 1].z
      );

      firstToSecond135.setLength(40);
      secondToFirst135.setLength(40);

      if (intermediatePoints[i][0].is135) {
        this.intermediatePoints[i][0].add(secondToFirst135);
      }

      if (intermediatePoints[i][this.intermediatePoints[i].length - 1].is135) {
        this.intermediatePoints[i][this.intermediatePoints[i].length - 1].add(firstToSecond135);
      }

      const intermLength = this.intermediatePoints.length;

      const rails = this.addHandrailAndBaserail(
        floor,
        this.intermediatePoints[i][0],
        this.intermediatePoints[i][this.intermediatePoints[i].length - 1],
        railingComponent,
        this.intermediatePoints[i ? i - 1 : intermLength - 1][0],
        this.intermediatePoints[i ? i - 1 : intermLength - 1][
          this.intermediatePoints[i ? i - 1 : intermLength - 1].length - 1
        ],
        this.intermediatePoints[(i + 1) % intermLength][0],
        this.intermediatePoints[(i + 1) % intermLength][
          this.intermediatePoints[(i + 1) % intermLength].length - 1
        ]
      );

      rails.forEach(r => this.railLightAppendService.addLightToRail(r));

      for (let j = 0; j < this.intermediatePoints[i].length - 1; j++) {
        const firstToSecond45 = new THREE.Vector3(
          this.intermediatePoints[i][j + 1].x - this.intermediatePoints[i][j].x,
          0,
          this.intermediatePoints[i][j + 1].z - this.intermediatePoints[i][j].z
        );
        const secondToFirst45 = new THREE.Vector3(
          this.intermediatePoints[i][j].x - this.intermediatePoints[i][j + 1].x,
          0,
          this.intermediatePoints[i][j].z - this.intermediatePoints[i][j + 1].z
        );
        firstToSecond45.setLength(15);
        secondToFirst45.setLength(15);

        if (intermediatePoints[i][j].is45) {
          this.intermediatePoints[i][j].add(secondToFirst45);
        }

        if (intermediatePoints[i][j + 1].is45) {
          this.intermediatePoints[i][j + 1].add(firstToSecond45);
        }

        let positions;
        switch (this.currentParams.infill) {
          case 'verticalCable':
            {
              positions = this.setPositionsForVerticalCables(
                this.intermediatePoints[i][j],
                this.intermediatePoints[i][j + 1]
              );
              for (let k = 0; k < positions.length; k++) {
                // this.addSingleVerticalPicket(this.intermediatePoints[i][j], this.intermediatePoints[i][j + 1]);
                if (positions[k].isPicket) {
                  this.addVerticalPicket(positions[k]);
                } else {
                  this.addVerticalCable(positions[k]);
                }
              }
              this.addSingleVerticalPicketForVerticalCables(
                this.intermediatePoints[i][j],
                this.intermediatePoints[i][j + 1]
              );
            }
            break;
          case 'horizontalCableBaserail':
            {
              this.addHorizontalCables(
                this.intermediatePoints[i][j],
                this.intermediatePoints[i][j + 1]
              );
            }
            break;
          case 'horizontalCable':
            {
              this.addHorizontalCables(
                this.intermediatePoints[i][j],
                this.intermediatePoints[i][j + 1]
              );
            }
            break;
          default:
            // glass / laser-cut / steel-mesh panel infills (see InfillTypes)
            if (isPanelInfill(this.currentParams.infill)) {
              this.addAndCutInfill(
                this.intermediatePoints[i][j],
                this.intermediatePoints[i][j + 1],
                this.currentParams.infill
              );
            }
            break;

          case 'verticalPicket': {
            positions = this.setPositionsForVerticalCables(
              this.intermediatePoints[i][j],
              this.intermediatePoints[i][j + 1]
            );
            for (let k = 0; k < positions.length; k++) {
              this.addVerticalPicket(positions[k]);
            }
            break;
          }
        }

        if (intermediatePoints[i][j].is45 || intermediatePoints[i][j].is135) {
          this.intermediatePoints[i][j].add(firstToSecond45);
        }

        if (intermediatePoints[i][j + 1].is45 || intermediatePoints[i][j + 1].is135) {
          this.intermediatePoints[i][j + 1].add(secondToFirst45);
        }
      }

      if (intermediatePoints[i][0].is135) {
        this.intermediatePoints[i][0].add(firstToSecond135);
      }

      if (intermediatePoints[i][this.intermediatePoints[i].length - 1].is135) {
        this.intermediatePoints[i][this.intermediatePoints[i].length - 1].add(secondToFirst135);
      }
    }
  }

  private isTiersSuperstructureType(point) {
    return (
      point.superstructureType === 'tier1StepDown' ||
      point.superstructureType === 'tier2StepDown' ||
      point.superstructureType === 'tier3StepDown' ||
      point.superstructureType === 'tier1StepUp' ||
      point.superstructureType === 'tier2StepUp' ||
      point.superstructureType === 'tier3StepUp'
    );
  }

  addAngleToHandrail(
    obj,
    rightVerticalAngle,
    leftVerticalAngle,
    rightHorizontalAngle,
    leftHorizontalAngle
  ) {
    const position = obj.geometry.attributes.position;
    const vertices = [];

    for (let i = 0, l = position.count; i < l; i++) {
      const vertice = new THREE.Vector3();
      vertice.fromBufferAttribute(position, i);
      vertice.applyMatrix4(obj.matrixWorld);
      vertices.push(vertice.clone());
    }

    for (let i = 0; i < vertices.length; i++) {
      // angle might be null (undefined),
      // in that case do not apply morph
      // manipulating vertical angles
      if (rightVerticalAngle && rightVerticalAngle > 0) {
        if (vertices[i].x > 0 && vertices[i].y > 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(rightVerticalAngle));
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }

        if (vertices[i].x > 0 && vertices[i].y < 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(rightVerticalAngle));
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      } else {
        if (vertices[i].x > 0 && vertices[i].y > 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(rightVerticalAngle));
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
        if (vertices[i].x > 0 && vertices[i].y < 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(rightVerticalAngle));
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      }

      if (leftVerticalAngle && leftVerticalAngle > 0) {
        if (vertices[i].x < 0 && vertices[i].y > 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(leftVerticalAngle));
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }

        if (vertices[i].x < 0 && vertices[i].y < 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(leftVerticalAngle));
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      } else {
        if (vertices[i].x < 0 && vertices[i].y > 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(leftVerticalAngle));
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }

        if (vertices[i].x < 0 && vertices[i].y < 0) {
          const displacement = Math.abs(vertices[i].y) * Math.tan(Math.abs(leftVerticalAngle));
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      }
      // manipulating vertical angles

      // manipulating horizontal angles
      if (rightHorizontalAngle) {
        if (vertices[i].x > 0 && vertices[i].z > 0) {
          const displacement = Math.abs(vertices[i].z) * Math.tan(rightHorizontalAngle);
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }

        if (vertices[i].x > 0 && vertices[i].z < 0) {
          const displacement = Math.abs(vertices[i].z) * Math.tan(rightHorizontalAngle);
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      }

      if (leftHorizontalAngle) {
        if (vertices[i].x < 0 && vertices[i].z > 0) {
          const displacement = Math.abs(vertices[i].z) * Math.tan(leftHorizontalAngle);
          const displacementVect = new THREE.Vector3(-displacement, 0, 0);
          vertices[i].add(displacementVect);
        }

        if (vertices[i].x < 0 && vertices[i].z < 0) {
          const displacement = Math.abs(vertices[i].z) * Math.tan(leftHorizontalAngle);
          const displacementVect = new THREE.Vector3(displacement, 0, 0);
          vertices[i].add(displacementVect);
        }
      }
      // manipulating horizontal angles
    }

    const morphArr = [];

    vertices.forEach(v => {
      morphArr.push(v.x, v.y, v.z);
    });

    obj.geometry.morphAttributes.position = [];
    obj.geometry.morphAttributes.position[0] = new THREE.Float32BufferAttribute(
      new Float32Array(morphArr),
      3
    );
    obj.material.morphTargets = true;
    obj.updateMorphTargets();
    obj.morphTargetInfluences[0] = 1;
  }

  private linesIntersect(x1, z1, x2, z2, x3, z3, x4, z4) {
    // Check if none of the lines are of length 0
    if ((x1 === x2 && z1 === z2) || (x3 === x4 && z3 === z4)) {
      return false;
    }

    let denominator = (z4 - z3) * (x2 - x1) - (x4 - x3) * (z2 - z1);

    // Lines are parallel
    if (denominator === 0) {
      return false;
    }

    let ua = ((x4 - x3) * (z1 - z3) - (z4 - z3) * (x1 - x3)) / denominator;
    let ub = ((x2 - x1) * (z1 - z3) - (z2 - z1) * (x1 - x3)) / denominator;

    // is the intersection along the segments
    if (ua < 0 || ua > 1 || ub < 0 || ub > 1) {
      return false;
    }

    // Return a object with the x and y coordinates of the intersection
    let x = x1 + ua * (x2 - x1);
    let z = z1 + ua * (z2 - z1);

    return { x, y: 0, z };
  }

  private getVectorsIntersectionPoint(
    line1StartVector,
    line1EndVector,
    line2StartVector,
    line2EndVector,
    endStart
  ) {
    // minDistance is for ignoring adjacent vectors
    // in the case when they are not actually adjacent,
    // it might be if we're finding intersection point
    // for vector that far away from the actual (
    // for which we want to find inetersection).
    // for adjacent vectors we take (from array)
    // previous element and subsequent, if one of
    // them out of array number, get first or
    // last. But first of last might be not
    // adjacent one
    const minDistance = 40;

    if (endStart) {
      if (line2EndVector.distanceTo(line1StartVector) > minDistance) {
        return false;
      }
    } else {
      if (line2StartVector.distanceTo(line1EndVector) > minDistance) {
        return false;
      }
    }

    const line1StartVectorIntersect = line1StartVector.clone();
    const line1EndVectorIntersect = line1EndVector.clone();
    const startToEndLine1 = new THREE.Vector3(
      line1EndVectorIntersect.x - line1StartVectorIntersect.x,
      0,
      line1EndVectorIntersect.z - line1StartVectorIntersect.z
    );
    const endToStartLine1 = new THREE.Vector3(
      line1StartVectorIntersect.x - line1EndVectorIntersect.x,
      0,
      line1StartVectorIntersect.z - line1EndVectorIntersect.z
    );

    // make vectors longer to force them intersect
    startToEndLine1.setLength(1000);
    endToStartLine1.setLength(1000);

    line1StartVectorIntersect.add(startToEndLine1);
    line1EndVectorIntersect.add(endToStartLine1);

    const line2StartVectorIntersect = line2StartVector.clone();
    const line2EndVectorIntersect = line2EndVector.clone();
    const startToEndLine2 = new THREE.Vector3(
      line2EndVectorIntersect.x - line2StartVectorIntersect.x,
      0,
      line2EndVectorIntersect.z - line2StartVectorIntersect.z
    );
    const endToStartLine2 = new THREE.Vector3(
      line2StartVectorIntersect.x - line2EndVectorIntersect.x,
      0,
      line2StartVectorIntersect.z - line2EndVectorIntersect.z
    );

    // make vectors longer to force them intersect
    startToEndLine2.setLength(1000);
    endToStartLine2.setLength(1000);

    line2StartVectorIntersect.add(startToEndLine2);
    line2EndVectorIntersect.add(endToStartLine2);

    const pointIntersect = this.linesIntersect(
      line1StartVectorIntersect.x,
      line1StartVectorIntersect.z,
      line1EndVectorIntersect.x,
      line1EndVectorIntersect.z,
      line2StartVectorIntersect.x,
      line2StartVectorIntersect.z,
      line2EndVectorIntersect.x,
      line2EndVectorIntersect.z
    );

    return pointIntersect;
  }

  private getSuperstructurePoint(floor, point) {
    if (floor) {
      return floor.userData.points.find(p => {
        return (
          this.isTiersSuperstructureType(p) &&
          ((p.terminationPosts &&
            p.terminationPosts.first &&
            p.terminationPosts.first.x === point.x &&
            p.terminationPosts.first.y === point.y &&
            p.terminationPosts.first.z === point.z) ||
            (p.terminationPosts &&
              p.terminationPosts.second &&
              p.terminationPosts.second.x === point.x &&
              p.terminationPosts.second.y === point.y &&
              p.terminationPosts.second.z === point.z))
        );
      });
    }
  }

  private getTiersAngle(floor, superstructurePoint, point, adjacentPoint, direction) {
    let angle;

    if (superstructurePoint) {
      let anotherFloor; // might be parent or child;
      let anotherFloorSuperstructurePoint;

      if (superstructurePoint.parent) {
        anotherFloor = this.stage
          .getCompoundFloor()
          .children.find(tier => tier.userData.customId === floor.userData.parentCustomId);
        const secondFloorSuperstructurePointFirstPointIndex = anotherFloor.userData.points.findIndex(
          point => point.childCustomId === floor.userData.customId
        );
        anotherFloorSuperstructurePoint =
          anotherFloor.userData.points[secondFloorSuperstructurePointFirstPointIndex];
      } else if (!superstructurePoint.parent) {
        anotherFloor = this.stage
          .getCompoundFloor()
          .children.find(tier => tier.userData.customId === superstructurePoint.tierId);
        anotherFloorSuperstructurePoint =
          anotherFloor.userData.points[anotherFloor.userData.points.length - 1];
      }

      if (anotherFloorSuperstructurePoint && anotherFloorSuperstructurePoint.terminationPosts) {
        this.railingCalculationHelperService.getPositionsForTerminationPosts(
          anotherFloor,
          this.intermediatePost
        );
        let terminationPointPosition: string;
        let anotherFloorTerminationPoint, thisFloorTerminationPoint;

        Object.keys(superstructurePoint.terminationPosts).forEach(position => {
          if (
            superstructurePoint.terminationPosts[position].x === point.x &&
            superstructurePoint.terminationPosts[position].y === point.y &&
            superstructurePoint.terminationPosts[position].z === point.z
          ) {
            thisFloorTerminationPoint = superstructurePoint;
            terminationPointPosition = position;
          }
        });

        if (terminationPointPosition === 'first') {
          anotherFloorTerminationPoint = anotherFloorSuperstructurePoint.terminationPosts.second;
        } else if (terminationPointPosition === 'second') {
          anotherFloorTerminationPoint = anotherFloorSuperstructurePoint.terminationPosts.first;
        }

        if (anotherFloorTerminationPoint) {
          const firstVector = new THREE.Vector3(
            point.x - anotherFloorTerminationPoint.x,
            0,
            point.z - anotherFloorTerminationPoint.z
          );
          const secondVector = new THREE.Vector3(
            point.x - adjacentPoint.x,
            0,
            point.z - adjacentPoint.z
          );
          let orient;

          if (direction == 'left') {
            orient = secondVector.x * firstVector.z - secondVector.z * firstVector.x;
          } else {
            orient = firstVector.x * secondVector.z - firstVector.z * secondVector.x;
          }

          if (orient > 0 || orient == 0) {
            angle = -(Math.PI / 2 - firstVector.angleTo(secondVector) / 2);
          } else {
            angle = Math.PI / 2 - firstVector.angleTo(secondVector) / 2;
          }

          // this data will be used in RailingForTiersService
          // to add appropriate angle to handrails on tiers
          if (terminationPointPosition === 'first') {
            thisFloorTerminationPoint.terminationPosts.firstPostTierToFloorHalfAngle = angle;
            if (direction == 'left') {
              thisFloorTerminationPoint.terminationPosts.firstPostTierToFloorHalfAngle = -angle;
            }
          } else if (terminationPointPosition === 'second') {
            thisFloorTerminationPoint.terminationPosts.secondPostTierToFloorHalfAngle = angle;
            if (direction == 'left') {
              thisFloorTerminationPoint.terminationPosts.secondPostTierToFloorHalfAngle = -angle;
            }
          }
        }

        return angle;
      }
    }
  }

  private stopAtDoubleCornerPost(position) {
    // http://146.185.164.175:8080/browse/FR-744
    // Mitre Issue: Double corners with H-cable infill and either 150 or 100 top rail
    const cornerPost = this.cornerPoints.find(cp => {
      return (
        cp.floorPoint &&
        position.floorPoint &&
        !cp.notCorner &&
        cp.floorPoint.x === position.floorPoint.x &&
        cp.floorPoint.y === position.floorPoint.y
      );
    });

    return (
      cornerPost &&
      this.cornerPost.userData.entity.cornerType === 'Double' &&
      this.currentParams.railingType === 'DesignRail' &&
      (this.currentParams.topRail === '150s' || this.currentParams.topRail === '100s')
    );
  }

  addHandrailAndBaserail(
    floor,
    position1,
    position2,
    railingComponent,
    adjacentRightStart?,
    adjacentRightEnd?,
    adjacentLeftStart?,
    adjacentLeftEnd?,
    stair?
  ): Array<Feeney.Rail.IRail> {
    let postWidth;
    const result: Array<Feeney.Rail.IRail> = [];

    switch (this.currentParams.railingType) {
      case 'DesignRail': {
        postWidth = 5.14;
        break;
      }
      case 'Steel flat bar': {
        postWidth = 5.0028;
        break;
      }
      case 'Steel round tubular': {
        postWidth = 5.0028;
        break;
      }
      case 'Wood': {
        postWidth = this.intermediatePost.userData.entity.width - 0.25;
        break;
      }
      default: {
        // postWidth is the post's actual column; width is the base-plate
        // footprint, which is far wider on base-mounted posts
        postWidth =
          +this.intermediatePost.userData.entity.postWidth ||
          this.intermediatePost.userData.entity.width;
      }
    }

    let FirstToSecond = new THREE.Vector3(position2.x - position1.x, 0, position2.z - position1.z);
    FirstToSecond.setLength(postWidth);

    if (position1.isLowerPoint) {
      position1.add(FirstToSecond);
    }
    if (position2.isLowerPoint) {
      position2.add(FirstToSecond.negate());
    }

    const p1 = position1.clone();
    const p2 = position2.clone();

    this.baserail = railingComponent.baserail;
    this.handrail = stair ? railingComponent.handrailForStairs : railingComponent.handrail;

    const handrail = this.handrail.clone();
    const rails = [];

    for (let i = 0; i < handrail.children.length; i++) {
      if (handrail.children[i]) {
        handrail.children[i].geometry = this.handrail.children[i].geometry.clone();
        handrail.children[i].material = this.handrailMaterial;
      }
    }

    rails.push(handrail);

    if (this.currentParams.infill !== 'horizontalCable') {
      const baserail = this.baserail.clone();
      rails.push(baserail);
    }

    for (let i = 0; i < rails.length; i++) {
      const obj = rails[i];
      obj.visible = true;
      let finalPosition1 = position1.clone();
      let finalPosition2 = position2.clone();
      const productType = obj.userData.entity.productType;

      // for cases where no angles need for railing,
      // use the width of handrail as a addition to its end
      const firstToSecond = new THREE.Vector3(
        position2.x - position1.x,
        0,
        position2.z - position1.z
      );
      const secondToFirst = new THREE.Vector3(
        position1.x - position2.x,
        0,
        position1.z - position2.z
      );
      firstToSecond.setLength(this.handrail.userData.entity.width / 2);
      secondToFirst.setLength(this.handrail.userData.entity.width / 2);

      const firstToSecondIfStairs = firstToSecond.clone();
      const secondToFirstIfStairs = secondToFirst.clone();

      firstToSecondIfStairs.setLength(this.handrail.userData.entity.width);
      secondToFirstIfStairs.setLength(this.handrail.userData.entity.width);

      const norm = new THREE.Vector3(0, 0, 1);

      let angle = firstToSecond.angleTo(norm);
      if (firstToSecond.x < 0) {
        angle = -firstToSecond.angleTo(norm);
      }

      if (productType === 'Handrail') {
        this.railingColorsService.setExistingColor(obj, 'Top Rail', 'Handrail');
        obj.children.forEach(el => {
          if (el.name === 'TopCap') {
            this.railingColorsService.setExistingColor(obj, 'Top Cap');
          }
        });
        // handrails in many cases have one or two
        // angled ends, so we need to find a point
        // of intersection for two handrails
        // and give each of them anlged end
        // with the angle wich is equal half of
        // angle between them

        const posY = position1.y;
        let railLength, leftAngle, rightAngle;

        if (
          this.currentParams.railingType === 'DesignRail' &&
          (this.currentParams.topRail === '150s' || this.currentParams.topRail === '100s') &&
          this.cornerPost.userData.entity.cornerType === 'Double'
        ) {
          if (position1.Is45) {
            finalPosition1.add(
              secondToFirst.clone().setLength(this.handrail.userData.entity.width * 1.5)
            );
          }
          if (position2.Is45) {
            finalPosition2.add(
              firstToSecond.clone().setLength(this.handrail.userData.entity.width * 1.5)
            );
          }
          if (position1.Is135) {
            finalPosition1.add(
              secondToFirst.clone().setLength(this.handrail.userData.entity.width * 3)
            );
          }
          if (position2.Is135) {
            finalPosition2.add(
              firstToSecond.clone().setLength(this.handrail.userData.entity.width * 3)
            );
          }
        }

        if (position1.isStairPost) {
          finalPosition1.add(firstToSecondIfStairs);
        } else if (
          position1.isConnectedWithNonHorizontal &&
          this.currentParams.railingType === 'Wood'
        ) {
          firstToSecondIfStairs.setLength(2);
          finalPosition1.add(firstToSecondIfStairs);
          finalPosition1.add(secondToFirst);
        } else if (
          position1.isConnectedWithNonHorizontal &&
          this.currentParams.railingType === 'DesignRail' &&
          +this.intermediatePost.userData.entity.offset < 0
        ) {
          firstToSecondIfStairs.setLength(0.42);
          firstToSecondIfStairs.negate();
          finalPosition1.add(firstToSecondIfStairs);
          finalPosition1.add(secondToFirst);
        } else if (position1.dontCut) {
          if (this.currentParams.railingType === 'Composite') {
            firstToSecondIfStairs.setLength(0.8);
            finalPosition2.add(firstToSecondIfStairs);
          }
        } else {
          if (this.stopAtDoubleCornerPost(position1)) {
            if (position1.corner && position1.not90 && !position1.Is45 && !position1.Is135) {
              const cornerPost = this.cornerPoints.find(cp => {
                return (
                  cp.floorPoint &&
                  position1.floorPoint &&
                  !cp.notCorner &&
                  cp.first &&
                  cp.floorPoint.x === position1.floorPoint.x &&
                  cp.floorPoint.y === position1.floorPoint.y
                );
              });

              if (cornerPost) {
                finalPosition1 = new THREE.Vector3(cornerPost.x, cornerPost.y, cornerPost.z);
                const shift =
                  (this.intermediatePost.userData.entity.postWidth ||
                    this.intermediatePost.userData.entity.width) / 2;
                secondToFirst.negate().setLength(shift);
                finalPosition1.add(secondToFirst);
              }
            } else {
              const cornerPost = this.cornerPoints.find(cp => {
                return (
                  cp.floorPoint &&
                  position1.floorPoint &&
                  cp.floorPoint.x === position1.floorPoint.x &&
                  cp.floorPoint.y === position1.floorPoint.y
                );
              });

              let shift;

              if (cornerPost) {
                if (cornerPost.inside && this.insideCornerPost) {
                  // in case we have inside corner,
                  // the outerOffset might be different,
                  // because of the width of post
                  shift = this.insideCornerPost.userData.entity.outerOffset;
                } else {
                  shift = this.cornerPost.userData.entity.outerOffset;
                }

                secondToFirst.negate().setLength(shift);
                finalPosition1.add(secondToFirst);
              }
            }
          } else if (adjacentRightStart && adjacentRightEnd) {
            const pointIntersect1 = this.getVectorsIntersectionPoint(
              adjacentRightStart,
              adjacentRightEnd,
              position1,
              position2,
              false
            );

            if (pointIntersect1) {
              pointIntersect1.y = posY;
              finalPosition1 = new THREE.Vector3(
                pointIntersect1.x,
                pointIntersect1.y,
                pointIntersect1.z
              );
              const firstVector = new THREE.Vector3(
                pointIntersect1.x - adjacentRightStart.x,
                0,
                pointIntersect1.z - adjacentRightStart.z
              );
              const secondVector = new THREE.Vector3(
                pointIntersect1.x - position2.x,
                0,
                pointIntersect1.z - position2.z
              );
              const orient = firstVector.x * secondVector.z - firstVector.z * secondVector.x;

              if (orient > 0 || orient == 0) {
                rightAngle = -(Math.PI / 2 - firstVector.angleTo(secondVector) / 2);
              } else {
                rightAngle = Math.PI / 2 - firstVector.angleTo(secondVector) / 2;
              }
            } else {
              const superstructurePointForPosition = this.getSuperstructurePoint(floor, position1);

              if (superstructurePointForPosition) {
                rightAngle = this.getTiersAngle(
                  floor,
                  superstructurePointForPosition,
                  position1,
                  position2,
                  'right'
                );
              } else {
                finalPosition1.add(secondToFirst);
              }
            }
          } else {
            const superstructurePointForPosition = this.getSuperstructurePoint(floor, position1);

            if (superstructurePointForPosition) {
              rightAngle = this.getTiersAngle(
                floor,
                superstructurePointForPosition,
                position1,
                position2,
                'right'
              );
            } else {
              finalPosition1.add(secondToFirst);
            }
          }
        }

        if (position2.isStairPost) {
          finalPosition2.add(secondToFirstIfStairs);
        } else if (
          position2.isConnectedWithNonHorizontal &&
          this.currentParams.railingType === 'Wood'
        ) {
          secondToFirstIfStairs.setLength(position1.dontCut ? 6.9 : 2);
          finalPosition2.add(secondToFirstIfStairs);
          finalPosition2.add(firstToSecond);
        } else if (
          position2.isConnectedWithNonHorizontal &&
          this.currentParams.railingType === 'DesignRail' &&
          +this.intermediatePost.userData.entity.offset < 0
        ) {
          secondToFirstIfStairs.setLength(0.42);
          secondToFirstIfStairs.negate();
          finalPosition2.add(secondToFirstIfStairs);
          finalPosition2.add(firstToSecond);
        } else if (position2.dontCut) {
          if (this.currentParams.railingType === 'DesignRail') {
            secondToFirstIfStairs.setLength(0.5);
            finalPosition2.add(secondToFirstIfStairs);
          }
        } else {
          if (this.stopAtDoubleCornerPost(position2)) {
            if (position2.corner && position2.not90 && !position2.Is45 && !position2.Is135) {
              const cornerPost = this.cornerPoints.find(cp => {
                return (
                  cp.floorPoint &&
                  position2.floorPoint &&
                  !cp.notCorner &&
                  cp.second &&
                  cp.floorPoint.x === position2.floorPoint.x &&
                  cp.floorPoint.y === position2.floorPoint.y
                );
              });

              if (cornerPost) {
                finalPosition2 = new THREE.Vector3(cornerPost.x, cornerPost.y, cornerPost.z);
                const shift =
                  (this.intermediatePost.userData.entity.postWidth ||
                    this.intermediatePost.userData.entity.width) / 2;
                firstToSecond.negate().setLength(shift);
                finalPosition2.add(firstToSecond);
              }
            } else {
              const cornerPost = this.cornerPoints.find(cp => {
                return (
                  cp.floorPoint &&
                  position2.floorPoint &&
                  cp.floorPoint.x === position2.floorPoint.x &&
                  cp.floorPoint.y === position2.floorPoint.y
                );
              });

              let shift;

              if (cornerPost) {
                if (cornerPost.inside && this.insideCornerPost) {
                  // in case we have inside corner,
                  // the outerOffset might be different,
                  // because of the width of post
                  shift = this.insideCornerPost.userData.entity.outerOffset;
                } else {
                  shift = this.cornerPost.userData.entity.outerOffset;
                }

                firstToSecond.negate().setLength(shift);
                finalPosition2.add(firstToSecond);
              }
            }
          } else if (adjacentLeftStart && adjacentLeftEnd) {
            const pointIntersect2 = this.getVectorsIntersectionPoint(
              adjacentLeftStart,
              adjacentLeftEnd,
              position1,
              position2,
              true
            );

            if (pointIntersect2) {
              pointIntersect2.y = posY;
              finalPosition2 = new THREE.Vector3(
                pointIntersect2.x,
                pointIntersect2.y,
                pointIntersect2.z
              );
              const firstVector = new THREE.Vector3(
                pointIntersect2.x - adjacentLeftEnd.x,
                0,
                pointIntersect2.z - adjacentLeftEnd.z
              );
              const secondVector = new THREE.Vector3(
                pointIntersect2.x - position1.x,
                0,
                pointIntersect2.z - position1.z
              );
              const orient = firstVector.x * secondVector.z - firstVector.z * secondVector.x;

              if (orient > 0 || orient == 0) {
                leftAngle = Math.PI / 2 - firstVector.angleTo(secondVector) / 2;
              } else {
                leftAngle = -(Math.PI / 2 - firstVector.angleTo(secondVector) / 2);
              }
            } else {
              const superstructurePointForPosition = this.getSuperstructurePoint(floor, position2);

              if (superstructurePointForPosition) {
                leftAngle = this.getTiersAngle(
                  floor,
                  superstructurePointForPosition,
                  position2,
                  position1,
                  'left'
                );
              } else {
                finalPosition2.add(firstToSecond);
              }
            }
          } else {
            const superstructurePointForPosition = this.getSuperstructurePoint(floor, position2);

            if (superstructurePointForPosition) {
              leftAngle = this.getTiersAngle(
                floor,
                superstructurePointForPosition,
                position2,
                position1,
                'left'
              );
            } else {
              finalPosition2.add(firstToSecond);
            }
          }
        }

        railLength = finalPosition1.distanceTo(finalPosition2);
        const scaleX = railLength / obj.userData.entity.length;

        let leftVerticalAngle =
          (position1.isConnectedWithNonHorizontal ? Math.atan(7 / 9) / 2 : null) *
          (position1.isLowerPoint ? -1 : 1);
        let rightVerticalAngle =
          (position2.isConnectedWithNonHorizontal ? Math.atan(7 / 9) / 2 : null) *
          (position1.isLowerPoint ? -1 : 1);

        // need to scale children of handrail
        // because anly children have geometry.
        // We cannot use scale on their parent,
        // because angled parts will be stratched,
        // and the angles will be destorted.
        // Applying matrix applies scaling
        // to vertices, as though element
        // from the begining has this length
        obj.children.forEach(c => {
          if (c) {
            c.matrix.makeScale(scaleX, 1, 1);
            c.geometry.applyMatrix(c.matrix);
            this.addAngleToHandrail(
              c,
              leftVerticalAngle,
              rightVerticalAngle,
              -rightAngle,
              leftAngle
            );
          }
        });
      } else {
        // default case...just add half of width
        // or post width (in case post has a
        // bracket, that includes bracket in
        // its width)
        firstToSecond.negate();
        secondToFirst.negate();

        const baserailShift =
          (this.intermediatePost.userData.entity.postWidth ||
            this.intermediatePost.userData.entity.width) /
            2 -
          (this.intermediatePost.userData.entity.baserailOverlap
            ? this.intermediatePost.userData.entity.baserailOverlap
            : 0);

        secondToFirst.setLength(baserailShift);

        firstToSecond.setLength(baserailShift);
        // //

        // correct default case and reset
        // the length of secondToFirst/firstToSecond
        // vectors, if there're 90 degree corners, and
        // for that corners we have just one model,
        // outerOffset - data from db, that show,
        // how much we should shift baserail from
        // the intermediate points
        if (this.cornerPost.userData.entity.cornerType === 'Double') {
          let baserailShift1, baserailShift2;

          if (
            !position1.isTerminationPost &&
            position1.corner &&
            !position1.not90 &&
            !position1.Is45 &&
            !position1.Is135
          ) {
            const cornerPost1 = this.cornerPoints.find(cp => {
              return (
                cp.floorPoint &&
                position1.floorPoint &&
                cp.floorPoint.x === position1.floorPoint.x &&
                cp.floorPoint.y === position1.floorPoint.y
              );
            });

            if (cornerPost1 || position1.isConnectedWithHorizontal) {
              if (
                !position1.isConnectedWithHorizontal &&
                cornerPost1.inside &&
                this.insideCornerPost
              ) {
                // in case we have inside corner,
                // the outerOffset might be different,
                // because of the width of post
                const overlap = this.insideCornerPost.userData.entity.baserailOverlap
                  ? this.insideCornerPost.userData.entity.baserailOverlap
                  : 0;
                baserailShift1 = this.insideCornerPost.userData.entity.outerOffset - overlap;
              } else {
                const overlap = this.cornerPost.userData.entity.baserailOverlap
                  ? this.cornerPost.userData.entity.baserailOverlap
                  : 0;
                baserailShift1 = this.cornerPost.userData.entity.outerOffset - overlap;
              }
              secondToFirst.setLength(baserailShift1);
            }
          }

          if (
            !position2.isTerminationPost &&
            position2.corner &&
            !position2.not90 &&
            !position2.Is45 &&
            !position2.Is135
          ) {
            const cornerPost2 = this.cornerPoints.find(cp => {
              return (
                cp.floorPoint &&
                position2.floorPoint &&
                cp.floorPoint.x === position2.floorPoint.x &&
                cp.floorPoint.y === position2.floorPoint.y
              );
            });

            if (cornerPost2 || position2.isConnectedWithHorizontal) {
              if (
                !position2.isConnectedWithHorizontal &&
                cornerPost2.inside &&
                this.insideCornerPost
              ) {
                // in case we have inside corner,
                // the outerOffset might be different,
                // because of the width of post
                const overlap = this.insideCornerPost.userData.entity.baserailOverlap
                  ? this.insideCornerPost.userData.entity.baserailOverlap
                  : 0;
                baserailShift2 = this.insideCornerPost.userData.entity.outerOffset - overlap;
              } else {
                const overlap = this.cornerPost.userData.entity.baserailOverlap
                  ? this.cornerPost.userData.entity.baserailOverlap
                  : 0;
                baserailShift2 = this.cornerPost.userData.entity.outerOffset - overlap;
              }

              firstToSecond.setLength(baserailShift2);
            }
          }
        }
        // //

        // in case the corner is not 90 degree
        // one model (for corner) will be
        // changed to two models,
        // in that case intermediate point
        // and corner point might be different
        if (position1.corner && position1.not90 && !position1.Is45 && !position1.Is135) {
          const cornerPost1 = this.cornerPoints.find(cp => {
            return (
              cp.floorPoint &&
              position1.floorPoint &&
              !cp.notCorner &&
              cp.first &&
              cp.floorPoint.x === position1.floorPoint.x &&
              cp.floorPoint.y === position1.floorPoint.y
            );
          });

          if (cornerPost1) {
            finalPosition1 = new THREE.Vector3(cornerPost1.x, cornerPost1.y, cornerPost1.z);
          }
        }

        if (position2.corner && position2.not90 && !position2.Is45 && !position2.Is135) {
          const cornerPost2 = this.cornerPoints.find(cp => {
            return (
              cp.floorPoint &&
              position2.floorPoint &&
              !cp.notCorner &&
              cp.second &&
              cp.floorPoint.x === position2.floorPoint.x &&
              cp.floorPoint.y === position2.floorPoint.y
            );
          });

          if (cornerPost2) {
            finalPosition2 = new THREE.Vector3(cornerPost2.x, cornerPost2.y, cornerPost2.z);
          }
        }
        // //

        // avoid this case https://prnt.sc/rzm45b
        if (!position1.Is135) {
          finalPosition1.add(secondToFirst);
        }

        // avoid this case https://prnt.sc/rzm45b
        if (!position2.Is135) {
          finalPosition2.add(firstToSecond);
        }
        this.railingColorsService.setExistingColor(obj, 'Bottom Rail', 'Bottomrail');
        const railLength = finalPosition1.distanceTo(finalPosition2);
        obj.children[0].scale.x = railLength / obj.userData.entity.length;
      }

      const newP = new THREE.Vector3((p1.x + p2.x) / 2, 0, (p1.z + p2.z) / 2);
      if (this.handrail.userData.entity.handrailType === 'Composite') {
        newP.y = p1.y;
      }

      const position = new THREE.Vector3(
        finalPosition1.x / 2 + finalPosition2.x / 2,
        finalPosition1.y + obj.userData.entity.placementHeight + obj.userData.entity.height / 2,
        finalPosition1.z / 2 + finalPosition2.z / 2
      );

      const med = new THREE.Vector3(
        finalPosition2.x - finalPosition1.x,
        0,
        finalPosition2.z - finalPosition1.z
      );
      med.setLength(1);

      obj.rotation.y = angle + Math.PI / 2;

      obj.position.set(
        position.x,
        finalPosition1.y + obj.userData.entity.placementHeight + obj.userData.entity.height / 2,
        position.z
      );

      if (stair) {
        newP.y = p1.y;
      }

      obj.userData = { start: p1, end: p2, ...obj.userData };

      result.push({
        startPoint: p1,
        endPoint: p2,
        rail: obj,
        verticalPosition: productType === 'Handrail' ? 'Top' : 'Bottom',
        isHorizontal: true
      });

      obj.name = `${productType}Container`;
      obj.children.forEach(ch => (ch.castShadow = true));

      if (!((position1.dontCut || position2.dontCut) && i === 1)) {
        this.stage.add(obj);
        this.infills.push(obj);
      }
      if (i === 0) {
        if (position1.isLowerPoint) {
          position1.add(FirstToSecond.negate());
        }
        if (position2.isLowerPoint) {
          position2.add(FirstToSecond);
        }
      }
    }

    return result;
  }

  addSingleVerticalPicketForVerticalCables(pos1, pos2) {
    const firstToSecond = new THREE.Vector3(pos2.x - pos1.x, 0, pos2.z - pos1.z);
    const secondToFirst = new THREE.Vector3(pos1.x - pos2.x, 0, pos1.z - pos2.z);
    firstToSecond.setLength(this.cornerPost.userData.entity.width / 2);
    secondToFirst.setLength(this.cornerPost.userData.entity.width / 2);
    if (this.cornerPost.userData.entity.cornerType === 'Double') {
      if (!pos1.isTerminationPost && pos1.corner && !pos1.not90 && !pos1.Is45 && !pos1.Is135) {
        pos1.add(firstToSecond);
      }
      if (!pos2.isTerminationPost && pos2.corner && !pos2.not90 && !pos2.Is45 && !pos2.Is135) {
        pos2.add(secondToFirst);
      }
    }

    if (
      !(
        pos1.distanceTo(pos2) < this.sizeHelper.INCHToCM(42) &&
        pos1.distanceTo(pos2) > this.sizeHelper.INCHToCM(21)
      )
    )
      return;

    let rotationVector = new THREE.Vector3(pos1.x - pos2.x, 0, pos1.z - pos2.z);
    var norm = new THREE.Vector3(1, 0, 0);
    var angle = rotationVector.angleTo(norm);
    if (rotationVector.z > 0) {
      angle = -rotationVector.angleTo(norm);
    }
    let offsetVector = new THREE.Vector3(rotationVector.z, 0, -rotationVector.x);
    const pickHeight =
      this.verticalPicket.userData.entity.placementHeight +
      this.verticalPicket.userData.entity.height / 2 +
      this.dHeight;
    const picket = this.verticalPicket.clone();

    // picket.scale.y = 110 / 101.6;
    picket.children.forEach(ch => (ch.castShadow = true));
    offsetVector.setLength(+picket.userData.entity.offset);
    picket.visible = true;
    picket.rotation.y = angle;
    picket.position.set((pos1.x + pos2.x) / 2, pickHeight, (pos1.z + pos2.z) / 2);
    this.railingColorsService.setExistingColor(picket, 'Picket', 'Picket');
    // picket.position.y += (110 - 101.6) / 2;
    picket.position.add(offsetVector);
    this.stage.add(picket);
    this.infills.push(picket);

    if (this.cornerPost.userData.entity.cornerType === 'Double') {
      if (!pos1.isTerminationPost && pos1.corner && !pos1.not90 && !pos1.Is45 && !pos1.Is135) {
        pos1.add(secondToFirst);
      }
      if (!pos2.isTerminationPost && pos2.corner && !pos2.not90 && !pos2.Is45 && !pos2.Is135) {
        pos2.add(firstToSecond);
      }
    }
  }

  addSingleVerticalPicket(pos1, pos2) {
    // DockRail has no mid-span stabilizer picket in its catalog — the
    // component is not requested for it, so there is nothing to place
    if (!this.horizontalCableVerticalPicket) return;
    if (pos1.distanceTo(pos2) < this.sizeHelper.INCHToCM(36)) return;

    // Modern kit picket rule (spec p.2 rule 5): a section longer than one
    // 6 ft kit gets two evenly spaced intermediate pickets; other types keep
    // the single mid-span picket
    const picketFractions =
      this.currentParams.railingType === 'Modern' &&
      pos1.distanceTo(pos2) > this.sizeHelper.INCHToCM(MODERN_TWO_PICKET_ABOVE_INCHES)
        ? [1 / 3, 2 / 3]
        : [0.5];

    let rotationVector = new THREE.Vector3(pos1.x - pos2.x, 0, pos1.z - pos2.z);
    var norm = new THREE.Vector3(1, 0, 0);
    var angle = rotationVector.angleTo(norm);
    if (rotationVector.z > 0) {
      angle = -rotationVector.angleTo(norm);
    }
    let offsetVector = new THREE.Vector3(rotationVector.z, 0, -rotationVector.x);
    const pickHeight =
      this.horizontalCableVerticalPicket.userData.entity.placementHeight +
      this.horizontalCableVerticalPicket.userData.entity.height / 2 +
      this.dHeight;

    picketFractions.forEach(t => {
      const picket = this.horizontalCableVerticalPicket.clone();

      // picket.scale.y = 110 / 101.6;
      picket.children.forEach(ch => (ch.castShadow = true));
      offsetVector.setLength(+picket.userData.entity.offset);
      picket.visible = true;
      picket.rotation.y = angle;
      picket.position.set(
        pos1.x + (pos2.x - pos1.x) * t,
        pickHeight,
        pos1.z + (pos2.z - pos1.z) * t
      );

      this.verticalPicketService.setVerticalPicketColor(
        picket,
        this.currentParams.verticalPicketShapeType,
        this.currentParams.verticalPicketColorName,
        'Picket'
      );
      this.railingColorsService.setExistingColor(picket, 'Picket', 'Picket');

      // picket.position.y += (110 - 101.6) / 2;
      picket.position.add(offsetVector);

      if (picket.userData.entity.productType === 'Vertical Picket Without Baserail') {
        picket.scale.y =
          (this.handrail.userData.entity.placementHeight - picket.userData.entity.placementHeight) /
          picket.userData.entity.height;
        picket.position.y -=
          (picket.userData.entity.height -
            (this.handrail.userData.entity.placementHeight -
              picket.userData.entity.placementHeight)) /
          2;
      }

      this.stage.add(picket);
      this.infills.push(picket);
    });
  }

  setPositionsForVerticalCables(pos1, pos2) {
    const firstToSecond = new THREE.Vector3(pos2.x - pos1.x, 0, pos2.z - pos1.z);
    const secondToFirst = new THREE.Vector3(pos1.x - pos2.x, 0, pos1.z - pos2.z);
    firstToSecond.setLength(this.cornerPost.userData.entity.width / 2);
    secondToFirst.setLength(this.cornerPost.userData.entity.width / 2);
    if (this.cornerPost.userData.entity.cornerType === 'Double') {
      if (!pos1.isTerminationPost && pos1.corner && !pos1.not90 && !pos1.Is45 && !pos1.Is135) {
        pos1.add(firstToSecond);
      }
      if (!pos2.isTerminationPost && pos2.corner && !pos2.not90 && !pos2.Is45 && !pos2.Is135) {
        pos2.add(secondToFirst);
      }
    }

    const length = pos1.distanceTo(pos2) - 10;
    for (let i = 1; length / i > 7.62; i++) {
      if (length / i < 10.16) {
        var count = i - 1;
        var offset = length / i;
      }
    }

    if (
      length + 10 < this.sizeHelper.INCHToCM(42) &&
      length + 10 > this.sizeHelper.INCHToCM(21) &&
      count % 2 === 0
    ) {
      count -= 1;
      offset = length / (count + 1);
    }

    let firstPicket = null,
      secondPicket = null;

    if (length + 10 > this.sizeHelper.INCHToCM(42)) {
      switch ((count + 1) % 3) {
        case 0:
          {
            firstPicket = (count + 1) / 3 - 1;
          }
          break;
        case 1:
          {
            firstPicket = Math.floor((count + 1) / 3) - 1;
          }
          break;
        case 2: {
          firstPicket = Math.ceil((count + 1) / 3) - 1;
        }
      }
      secondPicket = count - firstPicket - 1;
    }

    const points: any = [];
    const position = pos1.clone();
    const direction = new THREE.Vector3(pos2.x - pos1.x, 0, pos2.z - pos1.z);
    direction.setLength(5);
    position.add(direction);
    direction.setLength(offset);
    for (let i = 0; i < count; i++) {
      position.add(direction);
      const pos = position.clone();
      if (i === firstPicket || i === secondPicket) {
        pos.isPicket = true;
      }
      points.push(pos);
    }

    if (this.cornerPost.userData.entity.cornerType === 'Double') {
      if (!pos1.isTerminationPost && pos1.corner && !pos1.not90 && !pos1.Is45 && !pos1.Is135) {
        pos1.add(secondToFirst);
      }
      if (!pos2.isTerminationPost && pos2.corner && !pos2.not90 && !pos2.Is45 && !pos2.Is135) {
        pos2.add(firstToSecond);
      }
    }

    return points;
  }

  addVerticalCable(position) {
    const obj = this.verticalCable.clone();
    obj.visible = true;

    this.railingColorsService.setExistingColor(obj, 'Cable', 'CablesV');

    const height =
      this.verticalCable.userData.entity.placementHeight +
      this.verticalCable.userData.entity.height / 2 +
      this.dHeight;

    // obj.scale.x = 0.1;
    obj.scale.y = 1.1;
    obj.position.set(position.x, height, position.z);

    this.stage.add(obj);
    this.infills.push(obj);
    // });
  }

  addVerticalPicket(position) {
    const obj = this.verticalPicket.clone();
    obj.name = 'PicketContainer';
    obj.visible = true;
    const pickHeight =
      this.verticalPicket.userData.entity.placementHeight +
      this.verticalPicket.userData.entity.height / 2 +
      this.dHeight;
    // var height = this.verticalCable.userData.entity.placementHeight + this.verticalCable.userData.entity.height / 2 + this.dHeight;

    // obj.scale.x = 0.1;
    obj.position.set(position.x, pickHeight, position.z);

    this.railingColorsService.setExistingColor(obj, 'Picket Panel', 'Pickets');

    this.stage.add(obj);
    this.infills.push(obj);
    // });
  }

  addHorizontalCables(pos1, pos2) {
    const firstToSecond = new THREE.Vector3(pos2.x - pos1.x, 0, pos2.z - pos1.z);
    const secondToFirst = new THREE.Vector3(pos1.x - pos2.x, 0, pos1.z - pos2.z);

    if (this.cornerPost.userData.entity.cornerType === 'Double') {
      firstToSecond.setLength(this.cornerPost.userData.entity.width / 2);
      secondToFirst.setLength(this.cornerPost.userData.entity.width / 2);

      if (!pos1.isTerminationPost && pos1.corner && !pos1.not90 && !pos1.Is45 && !pos1.Is135) {
        pos1.add(firstToSecond);
      }
      if (!pos2.isTerminationPost && pos2.corner && !pos2.not90 && !pos2.Is45 && !pos2.Is135) {
        pos2.add(secondToFirst);
      }
    }

    if (pos1.corner && pos1.not90 && !pos1.Is45 && !pos1.Is135) {
      const cornerPost1 = this.cornerPoints.find(cp => {
        return (
          cp.floorPoint &&
          pos1.floorPoint &&
          cp.floorPoint.x === pos1.floorPoint.x &&
          cp.floorPoint.y === pos1.floorPoint.y
        );
      });

      firstToSecond.setLength(
        (this.intermediatePost.userData.entity.postWidth ||
          this.intermediatePost.userData.entity.width) / 2
      );

      if (cornerPost1) {
        pos1.add(firstToSecond);
      }
    }

    if (pos2.corner && pos2.not90 && !pos2.Is45 && !pos2.Is135) {
      const cornerPost2 = this.cornerPoints.find(cp => {
        return (
          cp.floorPoint &&
          pos2.floorPoint &&
          cp.floorPoint.x === pos2.floorPoint.x &&
          cp.floorPoint.y === pos2.floorPoint.y
        );
      });

      secondToFirst.setLength(
        (this.intermediatePost.userData.entity.postWidth ||
          this.intermediatePost.userData.entity.width) / 2
      );

      if (cornerPost2) {
        pos2.add(secondToFirst);
      }
    }

    this.addSingleVerticalPicket(pos1, pos2);

    const length = pos1.distanceTo(pos2); // - this.intermediatePost.userData.entity.width;

    const height =
      this.horizontalCable.userData.entity.placementHeight +
      this.horizontalCable.userData.entity.height / 2 +
      this.dHeight;

    const obj = this.horizontalCable.clone();
    obj.children.forEach(ch => (ch.castShadow = true));
    obj.visible = true;
    obj.scale.x = length / this.horizontalCable.userData.entity.length;
    obj.position.set((pos1.x + pos2.x) / 2, height, (pos1.z + pos2.z) / 2);
    const med = new THREE.Vector3(pos2.x - pos1.x, 0, pos2.z - pos1.z);
    med.setLength(1);
    const angle = Math.atan(med.z / med.x);

    obj.rotation.y = angle;
    obj.rotation.y = Math.PI - obj.rotation.y;

    this.stage.add(obj);
    this.infills.push(obj);

    if (this.cornerPost.userData.entity.cornerType === 'Double') {
      if (!pos1.isTerminationPost && pos1.corner && !pos1.not90 && !pos1.Is45 && !pos1.Is135) {
        pos1.add(secondToFirst);
      }
      if (!pos2.isTerminationPost && pos2.corner && !pos2.not90 && !pos2.Is45 && !pos2.Is135) {
        pos2.add(firstToSecond);
      }
    }
  }

  addAndCutInfill(pos1, pos2, infillType: string) {
    if (!this[infillType]) {
      console.warn(`Infill type '${infillType}' not found`);
      return;
    }

    const firstToSecond = new THREE.Vector3(pos2.x - pos1.x, 0, pos2.z - pos1.z);
    const secondToFirst = new THREE.Vector3(pos1.x - pos2.x, 0, pos1.z - pos2.z);

    firstToSecond.setLength(this.cornerPost.userData.entity.width / 2);
    secondToFirst.setLength(this.cornerPost.userData.entity.width / 2);

    if (this.cornerPost.userData.entity.cornerType === 'Double') {
      if (!pos1.isTerminationPost && pos1.corner && !pos1.not90 && !pos1.Is45 && !pos1.Is135) {
        pos1.add(firstToSecond);
      }
      if (!pos2.isTerminationPost && pos2.corner && !pos2.not90 && !pos2.Is45 && !pos2.Is135) {
        pos2.add(secondToFirst);
      }
    }

    if (infillType.indexOf('steelMesh') + 1) {
      this[infillType].children[0].material = this.cornerPost.children[0].material;
      this[infillType].children[1].material = this.cornerPost.children[0].material;
    }

    this.infillClippedByFourPointsService.add(
      pos1,
      pos2,
      this[infillType],
      this.baserail,
      this.handrail,
      this.intermediatePost,
      this.infills,
      Infills.horizontal
    );
  }

  updateCurrentParams() {
    this.currentParams = this.dataForMenu.getCurrentParams();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/railing/infills/infills.service.ts